import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Linkify from 'linkifyjs/react';

import MarkdownMessage from '../MarkdownMessage';

const MAX_URL_DISPLAY_LENGTH = 28;

const formatter = (value, type) => {
  if (type === 'url' && value.length > MAX_URL_DISPLAY_LENGTH) {
    const shortUrl = value.slice(0, MAX_URL_DISPLAY_LENGTH - 3);
    return `${shortUrl}...`;
  }
  return value;
};

const linkifyOptions = {
  target: { url: '_blank', rel: 'noopener noreferrer' },
  format: formatter,
};

export default class MessageWithLinks extends PureComponent {
  renderMessage() {
    const { text, markdown } = this.props;

    if (markdown) {
      return <MarkdownMessage text={text} />;
    }

    return text;
  }
  render() {
    return (
      <Linkify role="log" aria-live="assertive" aria-relevant="additions" aria-atomic="true" options={linkifyOptions}>
        {this.renderMessage()}
      </Linkify>
    );
  }
}

MessageWithLinks.propTypes = {
  text: PropTypes.string,
  markdown: PropTypes.bool,
};

MessageWithLinks.defaultProps = {
  text: '',
  markdown: false,
};
